export default "__VITE_ASSET__BYUv46BR__"